import GenerateWhatsAppProtocolIdUseCase from './implementations/GenerateWhatsAppProtocolIdUseCase';

let instance: GenerateWhatsAppProtocolIdUseCase | null = null;

export default function makeGenerateWhatsAppProtocolIdUseCase() {
  if (!instance) {
    instance = new GenerateWhatsAppProtocolIdUseCase();
  }

  return instance;
}
